import { ChangeDetectionStrategy, Component, computed, inject, OnInit, output, signal } from '@angular/core';

import { GridOptions, GridEmitter, UiGridComponent } from '@program-suite/ui-grid';
import { ButtonComponent } from '@program-suite/ui';
import { ViewSubmissionStore, DocumentGridRowViewModel } from '@program-suite/data-common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'lib-policy-documents',
  templateUrl: './policy-documents.component.html',
  styleUrls: ['./policy-documents.component.scss', '../view-submission.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    UiGridComponent,
    ButtonComponent
],
})
export class PolicyDocumentsComponent implements OnInit {
  viewSubmissionStore = inject(ViewSubmissionStore);
  changeTabEvent = output<string>();
  pageSizeMax = 2147483647;
  id: string | null = null;
  data = computed<DocumentGridRowViewModel[]>(() => this.viewSubmissionStore.policyDocuments?.() ?? []);
  filterValues = signal<any>({pageSize: this.pageSizeMax, sortOrder: {active: 'createdDate', direction: 'desc'}});
  gridOptions = signal<GridOptions>(
    {
      filterData: [],
      filterValues: this.filterValues,
      openFilters: true,
      columns: [
        { header: 'Created', controlName: 'createdDate', displayPipe: 'date'},
        { header: 'Type', controlName: 'documentType'},
        { header: 'File Name', controlName: 'name'},
        { header: 'Created By', controlName: 'createdBy'},
        { header: 'Manage', controlName: 'action', 
          actionColumnitems: [
            { type: 'icon', buttonAction: 'action',
              conditionalDisplay: { calculateDisplay: () => 'download', column: 'FileName' },
             },
          ]
        }
      ],
      data: this.data,
      frontEndPagination: true,
      fetchData: false,
      displaySearch: false,
      hidepagination: true,
    }
  );

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    // TODO get policy Id?
    this.id = this.route.snapshot.paramMap.get('id');
  }

  fetchAll(rawParams?: any) {
    this.viewSubmissionStore.getPolicyDocuments(this.id ?? '');
  }

  downloadPolicyBundle() {
    this.viewSubmissionStore.downloadDocument(this.id ?? '', true);
  }

  actionEvent(event: GridEmitter) {
    if (event.action === 'fetchAll') {
      this.fetchAll(event.data);
    } else if (event.action === 'formChanges') {
      // this.fetchAll(event.data);
    } else if (event.action === 'clearFilters') {
      // this.fetchAll(event.data);
    } else if (event.action === 'onDestroy') {
      // this.submissionGridStore.setFilterValues(event.data ?? {});
    } else if (event.action === 'action') {
      var policyGuid:string|null = null;
      //@ts-ignore
      if (event.data?.documentType == "Notice") {
        policyGuid = this.id;
      }
      //@ts-ignore
      this.viewSubmissionStore.downloadDocument(event.data?.id, event.data?.documentType == 'Policy' || event.data?.documentType == 'Submission', policyGuid);
    }
  }
}
